import { useCallback, useEffect, useState } from 'react'

type ScreenState = 'create' | 'success'

/**
 * Manages screen state synchronized with browser history.
 * Enables back/forward button navigation between Create and Success screens.
 *
 * Why not Router5? DirectMobileWeb is a lightweight entrypoint with only 2 screens
 * and no need for route params, deep linking, or the MWI navigation history system.
 * Adding Router5 infrastructure would be overkill for a simple Create → Success flow.
 */
const useHistoryState = () => {
  const [screen, setScreen] = useState<ScreenState>('create')

  const navigateToSuccess = useCallback(() => {
    window.history.pushState({ screen: 'success' }, '')
    setScreen('success')
  }, [])

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      setScreen(event.state?.screen === 'success' ? 'success' : 'create')
    }
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  return { showSuccessScreen: screen === 'success', navigateToSuccess }
}

export default useHistoryState
